// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"842d28fd","459":"054f06f2"}[chunkId] + ".chunk.css";
};